<template>
  <div class="notesList_wrapper wrapper">
    <transition name="fade" v-if="showModal">
      <Modal @close="invertModalStatus" :can-scroll="true">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>トラブルの際は…</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <div class="boxTxt_inner">
            <h3 class="inner">
              <span>よくある質問</span>
            </h3>
            <ul class="accordion_list">
              <li>
                <div class="accordionTxt_Wrapper">
                  <div @click.stop="collapseDeleteRoomMessage" class="menu_item_link js-menu_item_link wrapper">
                    <div class="title_area flex_center inner light">
                      <h4>
                        <span>ルームに前の人の書き込みが・・・</span>
                      </h4>
                      <div class="closeArrow_wrapper">
                        <fa-icon icon="angle-down" :transform="{rotate: accordions.collapseDeleteRoomMessage ? 180 : 0}" />
                      </div>
                    </div>
                  </div>
                  <transition name="toggle">
                    <div v-if="accordions.collapseDeleteRoomMessage" class="accordionTxt_body">
                      <div class="accordionTxt_Inner inner">
                        <p>
                          <span :style="{color: '#ff0000'}">会議室のチャットは、一般の会議室のホワイトボードと同じです。最後に消してください。</span>
                          <br />また前の人の投稿があった場合は、気にせず削除して会議室をお使い下さい。
                        </p>
                      </div>
                    </div>
                  </transition>
                </div>
              </li>
              <li>
                <div class="accordionTxt_Wrapper">
                  <div @click.stop="collapseCanNotJoinRoom" class="menu_item_link js-menu_item_link wrapper">
                    <div class="title_area flex_center inner light">
                      <h4>
                        <span>ルームに入れない</span>
                      </h4>
                      <div class="closeArrow_wrapper">
                        <fa-icon icon="angle-down" :transform="{rotate: accordions.collapseCanNotJoinRoom ? 180 : 0}" />
                      </div>
                    </div>
                  </div>
                  <transition name="toggle">
                    <div v-if="accordions.collapseCanNotJoinRoom" class="accordionTxt_body">
                      <div class="accordionTxt_Inner inner">
                        <p>
                          ビデオ会議ルームには定員の設定（右上の人数）があります。定員になっている場合は入れないため、ご了承ください。今のところYoutube等の映像をみるシアタールームには制限はありません。
                        </p>
                      </div>
                    </div>
                  </transition>
                </div>
              </li>
              <li>
                <div class="accordionTxt_Wrapper">
                  <div @click.stop="collapseHowToRecoveryErrors" class="menu_item_link js-menu_item_link wrapper">
                    <div class="title_area flex_center inner light">
                      <h4>
                        <span>システムの動きがおかしい</span>
                      </h4>
                      <div class="closeArrow_wrapper">
                        <fa-icon icon="angle-down" :transform="{rotate: accordions.collapseHowToRecoveryErrors ? 180 : 0}" />
                      </div>
                    </div>
                  </div>
                  <transition name="toggle">
                    <div v-if="accordions.collapseHowToRecoveryErrors" class="accordionTxt_body">
                      <div class="accordionTxt_Inner inner">
                        <p>
                          ビデオ会議はコンピューターの性能を最大限使うため、お使いの機器の性能によっては処理が追い付かず、映像が乱れたり遅延したり、画面の表示がおかしくなったりすることがあります。このような場合は、一旦会議を出て入りなおす、リロードしていただく、ログアウトしてマシンの温度を下げる、などの対応を行うと改善する場合があります。
                        </p>
                      </div>
                    </div>
                  </transition>
                </div>
              </li>
              <li>
                <div class="accordionTxt_Wrapper">
                  <div @click.stop="collapseCanNotUseDevice" class="menu_item_link js-menu_item_link wrapper">
                    <div class="title_area flex_center inner light">
                      <h4>
                        <span>カメラ・マイクが使えない</span>
                      </h4>
                      <div class="closeArrow_wrapper">
                        <fa-icon icon="angle-down" :transform="{rotate: accordions.collapseCanNotUseDevice ? 180 : 0}" />
                      </div>
                    </div>
                  </div>
                  <transition name="toggle">
                    <div v-if="accordions.collapseCanNotUseDevice" class="accordionTxt_body">
                      <div class="accordionTxt_Inner inner">
                        <p>
                          通常、カメラやマイクは１つのアプリケーションが使用中の場合には、他のアプリケーションでは利用することができません。ZoomやTeamsなど、他のビデオ会議アプリをご利用中は、本サービスのご利用の際にカメラ・マイクがないという警告が出る場合がございます。この場合は、カメラやマイクをお使いのアプリを終了させて本ページをリロードすると改善することがあります。
                        </p>
                      </div>
                    </div>
                  </transition>
                </div>
              </li>
              <li>
                <div class="accordionTxt_Wrapper">
                  <div @click.stop="collapseMultipleLogin" class="menu_item_link js-menu_item_link wrapper">
                    <div class="title_area flex_center inner light">
                      <h4>
                        <span>複数ログイン</span>
                      </h4>
                      <div class="closeArrow_wrapper">
                        <fa-icon icon="angle-down" :transform="{rotate: accordions.collapseMultipleLogin ? 180 : 0}" />
                      </div>
                    </div>
                  </div>
                  <transition name="toggle">
                    <div v-if="accordions.collapseMultipleLogin" class="accordionTxt_body">
                      <div class="accordionTxt_Inner inner">
                        <p>
                          本サービスは１つのアカウントで１人しかログインできません。その為、スマホでログインして、同じG-PLUS-IDやゲストの招待コードでPCから入る、または複数のブラウザでログインすることはできないようになっておりますのでご了承ください。
                        </p>
                      </div>
                    </div>
                  </transition>
                </div>
              </li>
            </ul>
          </div>
          <div class="boxTxt_inner inner">
            <h3>
              <span>運営チームへメッセージ</span>
            </h3>
          </div>
          <div class="boxTxt_inner inner">
            <validation-observer v-slot="{handleSubmit, invalid}">
              <form @submit.prevent="handleSubmit(sendContactMessage)">
                <validation-provider rules="required|max:3000" name="メッセージ">
                  <textarea
                    v-model="contentForm.content"
                    placeholder="ご利用のOSやブラウザ、症状、操作手順など詳しく記載いただけると早期に問題解決に繋がる可能性が高くなります。またタイミングによっては連絡できない場合もありますが、ご連絡先（メール・電話番号）をご記載いただければ可能な限り折り返しさせていただきます。"
                  />
                </validation-provider>
                <div class="submtBtn_wrapper">
                  <button type="submit" class="btn" :disabled="invalid">送信</button>
                </div>
              </form>
            </validation-observer>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "../elements/Modal"

export default {
  name: "Trouble",
  components: {
    Modal
  },
  data: function() {
    return {
      accordions: {
        collapseDeleteRoomMessage: false,
        collapseCanNotJoinRoom: false,
        collapseHowToRecoveryErrors: false,
        collapseCanNotUseDevice: false,
        collapseMultipleLogin: false
      },
      contentForm: {
        content: null
      }
    }
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    invertModalStatus() {
      this.$emit("invert-modal-status")
    },
    collapseDeleteRoomMessage() {
      this.accordions.collapseDeleteRoomMessage = !this.accordions.collapseDeleteRoomMessage
    },
    collapseCanNotJoinRoom() {
      this.accordions.collapseCanNotJoinRoom = !this.accordions.collapseCanNotJoinRoom
    },
    collapseHowToRecoveryErrors() {
      this.accordions.collapseHowToRecoveryErrors = !this.accordions.collapseHowToRecoveryErrors
    },
    collapseCanNotUseDevice() {
      this.accordions.collapseCanNotUseDevice = !this.accordions.collapseCanNotUseDevice
    },
    collapseMultipleLogin() {
      this.accordions.collapseMultipleLogin = !this.accordions.collapseMultipleLogin
    },
    async sendContactMessage() {
      await this.$axios
        .post(`events/${this.$route.params.slug}/contacts`, this.contentForm)
        .then(response => {
          alert(response.data.message)
        })
        .catch(error => {
          alert(error.response.data.message)
        })
        .finally(() => {
          this.contentForm.content = null
          this.invertModalStatus()
        })
    }
  }
}
</script>
